import React from 'react';

const TestimonialSection = () => {
  return (
    <section className="testi-section">
      <p className="testi-text">"The founders who get premium valuations didn't get lucky. They prepared. Start now — or start explaining later."</p>
      <p className="testi-attr">— Sunil Nikhar &nbsp;·&nbsp; ValueARC</p>
    </section>
  );
};

export default TestimonialSection;
